/**
 * @author Sai Prasad
 * @class LogHomeownerIssue
 */

import React from "react";
import Select from "../../Select";
import Textarea from "../../Textarea";
import File from "../../File";
import Row from "../../Row";
import Col from "../../Col";
import Avatar from "../../Avatar";
import FontAwesomeIcon from "../../Icon";
import { FormwerksThemeColor } from "../../../styles/TenantStyles";
import Diagnosis from "../../Diagnosis/Diagnosis";
import "../ConfigurePropertyWalkThrough";
import CreatableSelect from "react-select/creatable";
import { crossIcon, USER_ROLES } from "../../../common/constants";
import { useSelector } from "react-redux";
import { onCheckUserCanAccessTheModule } from "../../../helpers/validationHelper";

const LogHomeownerIssue = ({
  walkthroughServiceRequestsByAsset,
  onSetSelectedSRId,
  selectedSRId,
  onShowImages,
  commonIssues,
  types,
  roleName,
  easyWalkThroughFormData,
  onHandleIssueSelected,
  onHandleIssueTypeSelected,
  onSetDescription,
  onSelectMultipleItems,
  onHandleDelete,
  onClearSRData,
  onHandleSave,
  onServiceRequestProcessing,
  setTags
}) => {
  const serviceRequestTags = useSelector(state => state.formOptions?.serviceRequestTags || []);
  const isEnabled = onCheckUserCanAccessTheModule([USER_ROLES.SUPER_ADMIN,USER_ROLES.ADMIN,USER_ROLES.PROPERTY_DEVELOPER]);

  const checkAttachment = data => {
    if (data && data.attachment) {
      let attachment = data.attachment.split("/");
      return attachment.length > 0 ? true : false;
    } else {
      return false;
    }
  };

  // function to display service requests
  const displayServiceRequests = () => {    
    const theme = localStorage.getItem("theme");
    return (
        walkthroughServiceRequestsByAsset.map((data, i) => (
          <div
            style={{ marginTop: 20 }}
            className="subareaapprovalform__serviceRequestList"
            onClick={() => {
              if (selectedSRId === null) {
                onSetSelectedSRId(data.id);
              } else if (selectedSRId === data.id) {
              } else {
                onSetSelectedSRId(data.id);
              }
            }}
          >
            <div className="subareaapprovalform__serviceRequestList__question">
              <div
                style={{
                  display: "flex",
                  alignItems: "center"
                }}
              >
                <div
                  className="subareaapprovalform__serviceRequestList__countIcon"
                  style={{
                    backgroundColor:
                    theme === "Formwerks" &&
                      FormwerksThemeColor
                  }}
                >
                  {" "}
                  <div
                    style={{
                      padding: 2,
                      paddingLeft: 6,
                      fontSize: 14
                    }}
                  >
                    {i + 1}
                  </div>
                </div>
                <div
                  style={{
                    marginLeft: 5,
                    color:
                    theme === "Formwerks" &&
                      FormwerksThemeColor
                  }}
                  className="subareaapprovalform__serviceRequestList__title"
                >
                  {data.description.substring(
                    0,
                    data.description.length > 20
                      ? "15"
                      : data.description.length
                  ) + (data.description.length < 20 ? "" : "...")}
                </div>
              </div>
              <div
                style={{ paddingTop: 2 }}
                onClick={() => {
                  if (selectedSRId === data.id) {
                    onSetSelectedSRId(null);
                  }
                }}
              >
                <FontAwesomeIcon
                  weight="solid"
                  glyph={
                    selectedSRId === data.id
                      ? "chevron-up"
                      : "chevron-right"
                  }
                />
              </div>
            </div>
            {selectedSRId == data.id && (
              <div className="subareaapprovalform__faq__answer">
                <div style={{ marginTop: 10 }}>
                  {(data.area && data.area.name) && (
                    <>
                      <Diagnosis
                        asset={data.area.name}
                        issueType={
                          data.issueType && data.issueType.id
                            ? data.issueType ?.name
                              : ''
                        }
                        label={"Room/Area"}
                      />
                      <Row>
                        <Col xs={6}>
                          <strong style={{ color: "#454F5B" }}>
                            Asset
                          </strong>
                          <br />
                          {data.assets?.item?.name
                              ? data.assets.item.name
                              : "—"}
                        </Col>
                      </Row>
                    </>
                  )}
                  <br />
                  <Row>
                    <Col xs={6}>
                      <strong style={{ color: "#454F5B" }}>
                        Description
                      </strong>
                      <br />
                      {data.description}
                    </Col>
                    <Col xs={6}>
                      {checkAttachment(data) && (
                        <div
                          className="avatarImgCenter"
                          onClick={() => onShowImages(data)}
                        >
                          <Avatar
                            badge={
                              data.attachment === ""
                                ? ""
                                : JSON.parse(data.attachment) &&
                                  JSON.parse(data.attachment).length >
                                  1
                                  ? "count"
                                  : ""
                            }
                            url={
                              data.attachment !== ""
                                ? JSON.parse(data.attachment)[0]
                                : null
                            }
                          />
                        </div>
                      )}
                    </Col>
                  </Row>
                  <br />
                  <Row>
                    <Col xs={12} md={8}>
                      <div
                        style={{
                          fontWeight: "600",
                          color: "#48C1BF",
                          textDecoration: "underline"
                        }}
                      >
                        ServiceRequest: #
                        {data.ticketNumber
                          ? data.ticketNumber
                          : data.ticketId}
                      </div>
                    </Col>
                  </Row>
                  <br />
                </div>
              </div>
            )}
          </div>
        ))
    )
  }
  return (
    <div className="servicesRequstPopupOverlay">
      <div className="servicesRequstPopup">
        <div class="cross_btn" onClick={onClearSRData}>
          <a href="#.">
            <svg
              width="16"
              height="16"
              viewBox="0 0 16 16"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path d={crossIcon} fill="white" />
            </svg>
          </a>
        </div>
        <div className="popupServices">
          <div class="log_an_banner">
            <div class="log_an_issue_section">
              <div class="issue_heading">
                {walkthroughServiceRequestsByAsset.length > 0 && (
                  <h2>Logged Issues</h2>
                )}
              </div>
              <div className="popup_scroll">
              {walkthroughServiceRequestsByAsset.length > 0 && displayServiceRequests()}
                <div class="issue_heading">
                  <h2>Log an Issue</h2>
                </div>
                {commonIssues &&
                  commonIssues.length > 0 &&
                  roleName !== "Home Owner" && (
                    <div className="select-dropdown">
                      <Select
                        value={
                          easyWalkThroughFormData.commonIssueId
                            ? easyWalkThroughFormData.commonIssueId
                            : ""
                        }
                        onChange={e => onHandleIssueSelected(e)}
                        options={commonIssues.map(item => ({
                          label:
                            item.description.length > 45
                              ? item.description.substring(0, 45) + "...."
                              : item.description,
                          value: item.id
                        }))}
                        placeholder="Common Issues"
                        required={false}
                        block
                      />
                    </div>
                  )}
                {roleName === "Home Owner" ? (
                  <div className="select__control select select--block issueTypeHead">
                    <b>Issue Type:</b> General
                  </div>
                ) : (
                    <div className="select-dropdown">
                      <Select
                        value={
                          easyWalkThroughFormData.issueTypeId
                            ? easyWalkThroughFormData.issueTypeId
                            : ""
                        }
                        onChange={e => onHandleIssueTypeSelected(e)}
                        options={
                          types.length > 0
                            ? types.map(item => ({
                              label: item.name,
                              value: item.id
                            }))
                            : [{ label: "No Issue Types", value: "id" }]
                        }
                        placeholder="Issue Type*"
                        block
                      />
                    </div>
                  )}
                <Textarea
                  placeholder="Description"
                  onChange={e => onSetDescription(e)}
                  value={easyWalkThroughFormData.description}
                  block
                />
                <div className="filespace">
                  <File
                    onSelect={files => onSelectMultipleItems(files)}
                    files={[]}
                    multiSelect={true}
                  />
                </div>

                {easyWalkThroughFormData.selectedImage &&
                  easyWalkThroughFormData.selectedImage.length > 0 &&
                  easyWalkThroughFormData.selectedImage.map((data, i) =>
                    data.isDeleted === true ? null : (
                      <Row>
                        <Col granola xs="12" md="9">
                          <div
                            style={{
                              cursor: "pointer",
                              width: "4px"
                            }}
                          >
                            <Avatar badge={""} url={data.preview} />{" "}
                          </div>
                        </Col>

                        <Col granola xs="12" md="3">
                          <div
                            onClick={() => onHandleDelete(data, i)}
                            style={{
                              cursor: "pointer",
                              width: "4px"
                            }}
                          >
                            <FontAwesomeIcon
                              glyph="times-circle"
                              weight="light"
                              size="small"
                            />
                          </div>
                        </Col>
                      </Row>
                    )
                  )}
                {isEnabled &&
                <div style={{ marginHorizontal: "20" }}>
                  <CreatableSelect
                    placeholder="Add or create tags"
                    closeMenuOnSelect={false}
                    isClearable
                    isMulti
                    options={
                      serviceRequestTags.length > 0
                        ? serviceRequestTags.map(item => ({
                          value: item.id,
                          label: item.name
                        }))
                        : []
                    }
                    value={
                      easyWalkThroughFormData.tags
                        ? easyWalkThroughFormData.tags
                        : []
                    }
                    onChange={(newValue, actionMeta) =>
                      setTags(newValue, actionMeta)
                    }
                  />
                </div>
                }
              </div>
              <div
                className="footer1"
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center"
                }}
              >
                <div className="new_btn">
                  <a href="#.">
                    <button
                      style={{
                        height: "35px",
                        border: "1px dotted black",
                        borderRadius: "5px",
                        backgroundColor: "#fff",
                        fontWeight: "bold",
                        cursor: "pointer",
                        marginTop: "5px",
                        pointerEvents:
                          (!easyWalkThroughFormData.issueTypeId ||
                            !easyWalkThroughFormData.description) &&
                          "none"
                      }}
                      onClick={() => {
                        onHandleSave("Addisuue");
                        onServiceRequestProcessing(true);
                      }}
                    >
                      + Save and Add Another
                    </button>
                  </a>
                </div>
                <div
                  class="next_btn text-right"
                  style={{
                    pointerEvents:
                      (!easyWalkThroughFormData.issueTypeId ||
                        !easyWalkThroughFormData.description) &&
                      "none"
                  }}
                  onClick={() => {
                    onHandleSave("");
                    onServiceRequestProcessing(true);
                  }}
                >
                  <a href="#.">Save</a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
export default LogHomeownerIssue;
